import { fromGroupedValues } from "@/pages/IntegrationsPage/components/organisms/TicketingConfigurationTab"

import type {
  GitHubConfigurationPayload,
  GitHubConfigurationValues
} from "./GitHubConfigurationPage.types"

// "github.com" → "GitHub.com"; everything else as-is.
export const getGithubHostDisplay = (host: string): string =>
  host.toLowerCase() === "github.com" ? "GitHub.com" : host

export const getGitHubInstallationUrl = ({
  host,
  name,
  id
}: Pick<GitHubConfigurationValues, "host" | "name" | "id">) =>
  `https://${host}/organizations/${name}/settings/installations/${id}`

const toStrings = (value: unknown) =>
  Array.isArray(value)
    ? value.filter((item): item is string => typeof item === "string")
    : []

// The whole form, notifications included while hidden behind the switch
export const toGitHubConfigurationPayload = (
  id: string,
  values: Record<string, unknown>
): GitHubConfigurationPayload => {
  const { enableComments, issuesEnabled, ...grouped } = values
  const groupedSettings = Object.fromEntries(
    Object.entries(grouped).map(([key, value]) => [key, toStrings(value)])
  )

  return {
    data: {
      id,
      enableComments: enableComments === true,
      issuesEnabled: issuesEnabled === true,
      issueNotifications: fromGroupedValues(groupedSettings)
    }
  }
}
